import { createSlice } from "@reduxjs/toolkit";
import { ScheduleSiteInspectionDTO } from "../../../common/types/common.dto.types";
import { ScheduleInspectionPageType } from "./ScheduleInspectionPage.types";

// ==============================|| VIEWS - PAGES - SCHEDULE INSPECTION - REDUCER ||============================== //

const initialState = {
  ScheduleInspection: {
    InspectionSetId: 0,
    InspectionSetName: "",
    InspectionName: "",
    AssessmentTypeId: 0,
    AssessmentTypeCode: "",
    Sites: [] as Array<ScheduleSiteInspectionDTO>,
    PlannedCompletionDate: null,
  },
  FilteredSites: [],
  NavigateToViewInspectionPage: false,
} as ScheduleInspectionPageType;

export const scheduleInspectionSlice = createSlice({
  name: "ScheduleInspection",
  initialState: initialState,
  reducers: {
    setScheduleInspectionInitialState: (
      state: ScheduleInspectionPageType,
      action: { payload: ScheduleInspectionPageType; type: string }
    ) => {
      return {
        ...state,
        ScheduleInspection: {
          InspectionSetId: action.payload.ScheduleInspection?.InspectionSetId,
          InspectionSetName:
            action.payload.ScheduleInspection?.InspectionSetName ?? "",
          InspectionName: action.payload.ScheduleInspection?.InspectionName,
          AssessmentTypeId: action.payload.ScheduleInspection?.AssessmentTypeId,
          AssessmentTypeCode:
            action.payload.ScheduleInspection?.AssessmentTypeCode,
          Sites: action.payload.ScheduleInspection?.Sites,
          PlannedCompletionDate:
            action.payload.ScheduleInspection?.PlannedCompletionDate ?? null,
        },
        NavigateToViewInspectionPage: false,
      };
    },
    setNavigateToViewInspectionPage: (
      state: ScheduleInspectionPageType,
      action: { payload: boolean; type: string }
    ) => {
      return {
        ...state,
        NavigateToViewInspectionPage: action.payload,
      };
    },
  },
});

export const scheduleInspectionReducerActions = scheduleInspectionSlice.actions;
export const scheduleInspectionReducer = scheduleInspectionSlice.reducer;
